import React from 'react'

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      fill='none'
      viewBox='0 0 16 16'
    >
      <path
        fill='#202020'
        fillOpacity='0.5'
        d='M11 3.2h2.4a.6.6 0 01.6.6v9.6a.6.6 0 01-.6.6H2.6a.6.6 0 01-.6-.6V3.8a.6.6 0 01.6-.6H5V2h1.2v1.2h3.6V2H11v1.2zM9.8 4.4H6.2v1.2H5V4.4H3.2v2.4h9.6V4.4H11v1.2H9.8V4.4zm3 3.6H3.2v4.8h9.6V8z'
      ></path>
    </svg>
  )
}

export default Icon
